/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
// Formik and Yup
import { useFormik } from "formik";
import TextError from "utils/TextError";
import * as Yup from "yup";

// Dashboard example components

import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// @mui material components
import Alert from "@mui/material/Alert";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// React-Select component and styling
import Select from "react-select";
// Functions from store
import {
  createDynamicColumn,
  createSku,
  editSku,
  getDynamicColumn,
  getItemMaster,
  getSkuManagement,
  getSkuManagementWithoutPagination,
  getSubModulesByRoleId,
  printSecondarySku,
  printSku,
} from "../../../store";

// Config
import Config from "../../../config/index";

// Cookies
import Cookies from "universal-cookie";

import CreateButton from "components/standardized-components/CreateButton";
import EditButton from "components/standardized-components/EditButton";
import PrintButton from "components/standardized-components/PrintButton";
import { addMinutes, format } from "date-fns";

const cookies = new Cookies();

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styleForPicklistViewModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "fit-content",
  maxHeight: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
  overflow: "scroll",
  width: { xs: 350, lg: 1000 },
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 300, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForRelease = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
};

const SkuManagement = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getSkuManagement,
  getSkuManagementReducer,
  editSku,
  printSku,
  getSkuManagementWithoutPagination,
  getSkuManagementWithoutPaginationReducer,
  itemMaster,
  getItemMaster,
  createSku,
  printSecondarySku,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  const desLength = Config.descriptionLength;

  let loginDetails = cookies.get("loginDetailsForWMS");

  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  let userId = loginDetails.data.userId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  const subModuleId = "798ee46e-3dc9-41f5-8376-98fab73a8ba1";

  let picklistTrackingModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "798ee46e-3dc9-41f5-8376-98fab73a8ba1",
  );

  let viewAccess = picklistTrackingModule
    ? picklistTrackingModule.actionId.includes(
        "8da7b524-2e11-4606-a46b-af3ec367d8f3",
      )
    : null;
  let editItemAccess = picklistTrackingModule
    ? picklistTrackingModule.actionId.includes(
        "0bf27b78-9c9b-4f59-b8cb-09a4a6a3903c",
      )
    : null;

  let printAccess = picklistTrackingModule
    ? picklistTrackingModule.actionId.includes(
        "8586ed62-f42a-4ce6-9078-956ddae1e73d",
      )
    : null;

  let createAccess = picklistTrackingModule
    ? picklistTrackingModule.actionId.includes(
        "9c381ceb-bd76-488a-a499-c084e7f6f7d3",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});

  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    viewAccess && getSkuManagement(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewAccess, pageNo, rowsPerPage, searchObject]);

  const statusOptions = [
    {
      label: "All Status",
      value: "",
    },
    {
      label: "Created",
      value: 0,
    },
    {
      label: "Released",
      value: 1,
    },
    {
      label: "Open(Picking)",
      value: 2,
    },
    {
      label: "Open(Picked)",
      value: 3,
    },
    {
      label: "Open(Delivering)",
      value: 4,
    },
    {
      label: "Delivered",
      value: 5,
    },
  ];

  const [state, setState] = useState({
    columns: [
      { Header: "SKU Code", accessor: "skuCode" },

      { Header: "Item", accessor: "itemCode" },

      { Header: "Qty", accessor: "qty" },
      {
        Header: "Type",
        accessor: "skuType",
      },
      { Header: "Primary SKU Code", accessor: "primarySkuCode" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "Actions",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  useEffect(() => {
    let tempPicklist = [];

    let data = getSkuManagementReducer.sku.data
      ? getSkuManagementReducer.sku.data
      : [];

    setPaginationObj(getSkuManagementReducer?.sku?.pagination);

    setLoading(getSkuManagementReducer.loading);

    data.map((picklist) => {
      const picklistObject = {
        privateKey: picklist.picklistCode,
        skuCode: picklist.skuCode,
        itemCode: picklist.itemCode,
        skuType: picklist.skuType,
        primarySkuCode: picklist.primarySkuCode,
        qty: picklist.qty,
        cd: picklist?.cd,
        status: (
          <button
            className={
              (picklist.status === 0 && `status-created`) ||
              (picklist.status === 1 && `status-warning`) ||
              (picklist.status === 2 && `status-info`) ||
              (picklist.status === 3 && `status-info`) ||
              (picklist.status === 4 && `status-info`) ||
              (picklist.status === 5 && `status-success`)
            }
            style={{ width: "5.5rem" }}
          >
            {(picklist.status === 0 && `Created`) ||
              (picklist.status === 1 && `Released`) ||
              (picklist.status === 2 && `Open(Picking)`) ||
              (picklist.status === 3 && `Open(Picked)`) ||
              (picklist.status === 4 && `Open(Delivering)`) ||
              (picklist.status === 5 && `Delivered`)}
          </button>
        ),

        action: (
          <span style={{ display: "flex" }}>
            {editItemAccess && (
              <EditButton
                tooltip="Edit"
                type="button"
                variant="gradient"
                color="success"
                style={{ borderRadius: "5px", marginRight: "5px" }}
                size="small"
                iconOnly
                onClick={() => {
                  //  setItemId(item.id);

                  //  setBinId(item.locationId);
                  handleOpenEditSingleItemMasterModal(picklist);
                }}
              >
                <Icon>edit</Icon>
              </EditButton>
            )}
            {printAccess && (
              <PrintButton
                tooltip="Print"
                type="button"
                variant="gradient"
                color="success"
                style={{ borderRadius: "5px" }}
                size="small"
                iconOnly
                onClick={() => {
                  //  setItemId(item.id);

                  //  setBinId(item.locationId);
                  handlePrintModal(picklist);
                }}
              >
                <Icon>print</Icon>
              </PrintButton>
            )}
          </span>
        ),
      };
      tempPicklist.push(picklistObject);
    });
    setState({ ...state, rows: tempPicklist });
  }, [getSkuManagementReducer]);

  const [selectedItemCode, setSelectedItemCode] = useState("");

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
        uom: item.uom,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);

  const [createErrorMsg, setCreateErrorMsg] = useState("");
  useEffect(() => {
    if (isSuccessAllocateItem) {
      setTimeout(() => {
        setIsSuccessAllocateItem(false);
      }, 3000);
    }
  }, [isSuccessAllocateItem]);

  useEffect(() => {
    if (isErrorAllocateItem) {
      setTimeout(() => {
        setIsErrorAllocateItem(false);
      }, 3000);
    }
  }, [isErrorAllocateItem]);

  const [isSuccessEditThreshold, setIsSuccessEditThreshold] = useState(false);
  const [isErrorEditThreshold, setIsErrorEditThreshold] = useState(false);
  const [isErrorMsgEditThreshold, setIsErrorMsgEditThreshold] = useState("");
  useEffect(() => {
    if (isSuccessEditThreshold) {
      setTimeout(() => {
        setIsSuccessEditThreshold(false);
      }, 3000);
    }
  }, [isSuccessEditThreshold]);
  useEffect(() => {
    if (isErrorEditThreshold) {
      setTimeout(() => {
        setIsErrorEditThreshold(false);
      }, 3000);
    }
  }, [isErrorEditThreshold]);

  const [editItemModal, setEditItemModal] = useState(false);
  const handleEditItemModal = () => {
    setEditItemModal(false);
    formik.setErrors({});
  };
  const handleCloseEditItemModal = () => {
    setEditItemModal(false);
    formik.setErrors({});
  };

  const [singleItemMasterDataForEdit, setSingleItemMasterDataForEdit] =
    useState({});

  const handleOpenEditSingleItemMasterModal = (data = {}) => {
    // formik.setValues(singleItemMasterDataForEdit);

    setSingleItemMasterDataForEdit(data);
    setEditItemModal(true);
  };

  const initialValueForEdit = {
    qty: singleItemMasterDataForEdit.qty ? singleItemMasterDataForEdit.qty : "",
  };

  const validationSchemaForEdit = Yup.object({
    qty: Yup.number()
      .required("Enter a valid qty")
      .positive("Qty must be positive"),
  });
  const [editButtonName, setEditButtonName] = useState("Submit");

  const onSubmitForEdit = async (values, { resetForm }) => {
    setEditButtonName("Please wait...");
    const payload = {
      skuId: singleItemMasterDataForEdit?.skuId,
      qty: values.qty,
    };

    let res = await editSku(payload);

    if (res.status) {
      setIsSuccessEditThreshold(true);
      getSkuManagement(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        setEditButtonName("Submit");
        handleCloseEditItemModal();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorEditThreshold(true);
      setIsErrorMsgEditThreshold(res.message.data.msg);
      setEditButtonName("Submit");
    }
    // resetForm();
  };

  const formik = useFormik({
    initialValues: initialValueForEdit,
    onSubmit: onSubmitForEdit,
    validationSchema: validationSchemaForEdit,
    enableReinitialize: true,
  });

  const [isSuccessPrint, setIsSuccessPrint] = useState(false);
  const [isErrorPrint, setIsErrorPrint] = useState(false);
  const [isErrorMsgPrint, setIsErrorMsgPrint] = useState("");
  useEffect(() => {
    if (isSuccessPrint) {
      setTimeout(() => {
        setIsSuccessPrint(false);
      }, 3000);
    }
  }, [isSuccessPrint]);
  useEffect(() => {
    if (isErrorPrint) {
      setTimeout(() => {
        setIsErrorPrint(false);
      }, 3000);
    }
  }, [isErrorPrint]);

  const [printModal, setPrintModal] = useState(false);
  const handlePrintModal = (data = {}) => {
    setEditButtonName("Submit");
    setSingleItemMasterDataForEdit(data);
    setPrintModal(true);
    formikForPrint.setErrors({});
  };
  const handleClosePrintModal = () => {
    setPrintModal(false);
    formikForPrint.setErrors({});
    formikForPrint.setValues({
      batchNumber: "",
      qty: "",
      secondarySkuCode: singleItemMasterDataForEdit?.skuCode,
    });
  };

  const handleOpenPrintSingleItemMasterModal = (data = {}) => {
    // formik.setValues(singleItemMasterDataForEdit);

    setSingleItemMasterDataForEdit(data);
    setEditItemModal(true);
  };

  const initialValueForPrint = {
    batchNumber: singleItemMasterDataForEdit.skuTypeId === 1 ? "" : undefined,
    qty: "",
    poNumber: singleItemMasterDataForEdit.skuTypeId === 1 ? "" : undefined,
    skuCode: singleItemMasterDataForEdit.skuTypeId === 1 ? "" : undefined,
    secondarySkuCode:
      singleItemMasterDataForEdit.skuTypeId === 2
        ? singleItemMasterDataForEdit.skuCode
        : "",
  };

  const validationSchemaForPrint = Yup.object({
    batchNumber:
      singleItemMasterDataForEdit.skuTypeId === 1
        ? Yup.string().required("Enter the batch number")
        : Yup.string(),
    qty: Yup.number()
      .required("Enter a valid qty")
      .positive("Qty must be positive"),
    poNumber:
      singleItemMasterDataForEdit.skuTypeId === 1
        ? Yup.string().required("PO Number is required")
        : Yup.string(),
  });

  const onSubmitForPrint = async (values, { resetForm }) => {
    setEditButtonName("Please wait...");
    const payload = {
      qty: values.qty,
      skuCode: singleItemMasterDataForEdit?.skuCode,
      // itemPrint: singleItemMasterDataForEdit.itemPrint === true ? 1 : 0,
      printType: "primary",
      productionOrderNumber: values.poNumber,
      mvtId: 12,
      batchNumber: values.batchNumber,
      itemCode: singleItemMasterDataForEdit?.itemCode,
    };

    const payload2 = {
      qty: values.qty,
      skuCode: singleItemMasterDataForEdit.skuCode,
      skuId: singleItemMasterDataForEdit.skuId,
    };

    let res;
    if (singleItemMasterDataForEdit.skuTypeId === 1) {
      res = await printSku(payload);
    }
    if (singleItemMasterDataForEdit.skuTypeId === 2) {
      res = await printSecondarySku(payload2);
    }

    if (res.status) {
      console.log(res);
      setIsSuccessPrint(true);
      getSkuManagement(pageNo, rowsPerPage, searchObject, jwtToken);
      try {
        // obtain base64 string (handle cases where the API returns object or raw string)
        let base64 = res?.data?.data?.base64PDF;
        if (!base64) throw new Error("No base64 PDF data found in response");

        // if value contains data URI prefix, strip it
        if (
          typeof base64 === "string" &&
          base64.indexOf(",") !== -1 &&
          base64.startsWith("data:")
        ) {
          base64 = base64.split(",")[1];
        }

        // decode base64 to binary
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        // create blob and trigger download
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        const name =
          singleItemMasterDataForEdit?.skuCode ?? `print_${Date.now()}`;
        link.href = blobUrl;
        link.download = `${name}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        // revoke object URL after short delay to ensure download started
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      } catch (err) {
        console.error("Failed to download PDF:", err);
        // show error to user if needed
        setIsErrorPrint(true);
        setIsErrorMsgPrint(err.message || "Failed to process PDF");
      }
      setTimeout(() => {
        setEditButtonName("Submit");
        handleClosePrintModal();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorPrint(true);
      setIsErrorMsgPrint(res.message.data.msg);
      setEditButtonName("Submit");
    }
    // resetForm();
  };

  const formikForPrint = useFormik({
    initialValues: initialValueForPrint,
    onSubmit: onSubmitForPrint,
    validationSchema: validationSchemaForPrint,
    enableReinitialize: true,
  });

  const [controlTypeSelected, setControlTypeSelected] = useState("");

  const handleChangeControlType = (selectedOption) => {
    setControlTypeSelected(selectedOption);
  };

  const [controlTypeOptions, setControlTypeOptions] = useState([]);

  useEffect(() => {
    let tempItemTypeOptions = [];
    let data = getSkuManagementWithoutPaginationReducer.sku.data
      ? getSkuManagementWithoutPaginationReducer.sku.data
      : [];
    data.map((itemType) => {
      tempItemTypeOptions.push({
        label: itemType.skuCode,
        value: itemType.skuId,
      });
    });
    setControlTypeOptions(tempItemTypeOptions);
  }, [getSkuManagementWithoutPaginationReducer]);

  const [skuTypeSelected, setSkuTypeSelected] = useState("");

  const handleChangeSkuType = (selectedOption) => {
    setSkuTypeSelected(selectedOption);
    getItemMaster(jwtToken);
    getSkuManagementWithoutPagination(jwtToken);
  };

  const skuTypeOptions = [
    {
      label: "Primary",
      value: 1,
    },
    {
      label: "Secondary",
      value: 2,
    },
  ];

  const [openCreateItemModal, setOpenCreateItemModal] = useState(false);

  const handleOpenCreateItemModal = () => {
    setOpenCreateItemModal(true);
    formikForCreateItem.setValues(initialValues);
    formikForCreateItem.setTouched({});

    setSelectedItemCode("");
    setControlTypeSelected("");
    // formikForCreateItem.setErrors({});
    setSkuTypeSelected("");
  };

  const handleCloseCreateItemModal = () => {
    setOpenCreateItemModal(false);
    setButtonName("Submit");
    // formikForCreateItem.setErrors({});
  };

  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  useEffect(() => {
    if (isSuccess) {
      setTimeout(() => {
        setIsSuccess(false);
      }, 3000);
    }
  }, [isSuccess]);
  useEffect(() => {
    if (isError) {
      setTimeout(() => {
        setIsError(false);
      }, 3000);
    }
  }, [isError]);

  const initialValues = {
    skuCode: "",
  };

  const validationSchema = Yup.object({
    skuCode: Yup.string()
      .required("Please enter the SKU code")
      .matches(
        /^SKU[123]_\d{3}$/,
        "SKU code must follow pattern: SKU1_001, SKU2_001, or SKU3_001",
      ),
    qty: Yup.number()
      .required("Please enter a valid qty")
      .positive("Qty must be positive"),
  });

  const [errorMsg, setErrorMsg] = useState("");

  const [buttonName, setButtonName] = useState("Submit");

  const onSubmit = async (values, { resetForm }) => {
    setButtonName("Please wait...");
    const payload = {
      skuCode: values.skuCode,
      qty: values.qty,
      itemPrint: values.itemPrint === false ? 0 : 1,
      skuTypeId: skuTypeSelected.value,
      itemId: selectedItemCode?.value,
      primarySkuId: controlTypeSelected?.value,
    };

    let res = await createSku(payload, jwtToken);
    if (res.status) {
      getSkuManagement(pageNo, rowsPerPage, searchObject, jwtToken);
      setIsSuccess(true);

      setTimeout(() => {
        setButtonName("Submit");
        handleCloseCreateItemModal();
      }, 2250);
    }
    if (!res.status) {
      setErrorMsg(res.message.data.msg);
      setIsError(true);
      setButtonName("Submit");
    }
  };

  const formikForCreateItem = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: onSubmit,
  });

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getSkuManagement(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <>
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox>
              <MDBox color="text" px={2} ml={-2} mb={1}>
                {" "}
                {createAccess && (
                  <CreateButton
                    tooltip="Create SKU"
                    // disabled={!createAccess}
                    color="info"
                    variant="contained"
                    type="button"
                    iconOnly
                    onClick={handleOpenCreateItemModal}
                    style={{ marginRight: "1rem", borderRadius: "5px" }}
                    size="small"
                  >
                    <Icon>add</Icon>
                  </CreateButton>
                )}
              </MDBox>

              <MDBox>
                <DataTable
                  table={{ columns, rows }}
                  isSorted
                  tableSearch
                  showTotalEntries
                  noEndBorder
                  loading={loading}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  serverSidePagination
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  /* Table options */
                  options={{ draggable: false }}
                  /* Column reorder */
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  /* Meta */
                  subModuleId={subModuleId}
                  userId={userId}
                />
              </MDBox>
            </MDBox>
          </Grid>
        </Grid>
        <Modal
          open={openCreateColumnReorderModal}
          onClose={handleCloseCreateColumnReorderModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{ backdropFilter: "blur(5px)" }}
        >
          <MDCard sx={styleForColumnReorder}>
            <MDTypography>Are you sure you want to submit?</MDTypography>
            <MDBox mt={2}>
              <MDButton
                style={{ width: "10rem", marginRight: "0.5rem" }}
                color="info"
                variant="outlined"
                onClick={handleCloseCreateColumnReorderModal}
              >
                Cancel
              </MDButton>
              <MDButton
                style={{ width: "10rem", marginLeft: "0.5rem" }}
                color="success"
                onClick={handleDynamicColumn}
                // disabled={denyButtonName === "Please wait..."}
              >
                Submit
              </MDButton>
            </MDBox>
            <MDBox mt={2}>
              <Collapse in={isSuccessColumnReorder}>
                <Alert
                  severity="success"
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setIsSuccessColumnReorder(false);
                      }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                >
                  Data updated successfully!
                </Alert>
              </Collapse>
              <Collapse in={isErrorColumnReorder}>
                <Alert
                  severity="error"
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setIsErrorColumnReorder(false);
                      }}
                    >
                      <CloseIcon fontSize="inherit" />
                    </IconButton>
                  }
                >
                  {isErrorMsgForColumnReorder}
                </Alert>
              </Collapse>
            </MDBox>
          </MDCard>
        </Modal>
        <Modal
          open={openCreateItemModal}
          onClose={handleCloseCreateItemModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <MDCard sx={styleForEdit}>
            <MDBox ml={3} mt={-1} display="flex" alignItems="center">
              <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                Create Sku
              </MDTypography>
              <MDBox>
                <Tooltip title="Close">
                  <IconButton
                    style={{
                      background: "whitesmoke",
                      color: "black",
                      borderRadius: 5,
                      marginLeft: "-55px",
                    }}
                    aria-label="close"
                    color="inherit"
                    onClick={handleCloseCreateItemModal}
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </MDBox>
            </MDBox>
            <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

            <MDBox pt={1} pb={3} px={3} overflow="auto">
              <MDBox
                component="form"
                role="form"
                onSubmit={formikForCreateItem.handleSubmit}
              >
                <MDBox mb={2}>
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    style={{ fontWeight: "500" }}
                  >
                    SKU Code
                  </MDTypography>

                  <MDInput
                    type="text"
                    name="skuCode"
                    className="select-css-for-itemcode"
                    fullWidth
                    autoComplete="off"
                    onBlur={formikForCreateItem.handleBlur}
                    onChange={formikForCreateItem.handleChange}
                    value={formikForCreateItem.values.skuCode}
                    error={
                      formikForCreateItem.touched.skuCode &&
                      formikForCreateItem.errors.skuCode &&
                      true
                    }
                    inputProps={{
                      style: {
                        height: "10px",
                      },
                      maxLength: 45,
                    }}
                  />
                  {formikForCreateItem.touched.skuCode &&
                    formikForCreateItem.errors.skuCode && (
                      <TextError msg={formikForCreateItem.errors.skuCode} />
                    )}
                </MDBox>

                <MDBox mb={2}>
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    style={{ fontWeight: "500" }}
                  >
                    Type
                  </MDTypography>

                  <Select
                    isClearable
                    className="select-css"
                    maxMenuHeight={130}
                    placeholder="Choose one..."
                    name="itemType"
                    onBlur={() => {
                      formik.handleBlur({
                        target: { name: "itemType" },
                      });
                    }}
                    value={skuTypeSelected}
                    options={skuTypeOptions}
                    onChange={(selectedOption) => {
                      handleChangeSkuType(selectedOption);
                      formikForCreateItem.setFieldValue(
                        "itemType",
                        selectedOption,
                      );
                    }}
                  />
                  {formikForCreateItem.touched.itemType &&
                    formikForCreateItem.errors.itemType && (
                      <TextError msg={formikForCreateItem.errors.itemType} />
                    )}
                </MDBox>
                {skuTypeSelected && skuTypeSelected.value === 1 && (
                  <MDBox>
                    <MDBox mb={2}>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        style={{ fontWeight: "500" }}
                      >
                        Item Code
                      </MDTypography>

                      <Select
                        isClearable
                        className="select-css"
                        maxMenuHeight={130}
                        placeholder="Choose one..."
                        name="itemCode"
                        value={selectedItemCode}
                        options={itemCodeOptions}
                        onBlur={formikForCreateItem.handleBlur}
                        onChange={(selectedOption) => {
                          handleItemCodeChange(selectedOption);
                          formikForCreateItem.setFieldValue(
                            "itemCode",
                            selectedOption,
                          );
                        }}
                      />
                      {formikForCreateItem.touched.itemCode &&
                        formikForCreateItem.errors.itemCode && (
                          <TextError
                            msg={formikForCreateItem.errors.itemCode}
                          />
                        )}
                    </MDBox>

                    <MDBox mb={1} mt={1} display="flex" alignItems="center">
                      <input
                        type="checkbox"
                        name="itemPrint"
                        checked={formikForCreateItem.values.itemPrint ?? true}
                        onChange={(e) =>
                          formikForCreateItem.setFieldValue(
                            "itemPrint",
                            e.target.checked,
                          )
                        }
                        onBlur={() =>
                          formikForCreateItem.handleBlur({
                            target: { name: "itemPrint" },
                          })
                        }
                        style={{ width: 18, height: 18, marginRight: 10 }}
                      />
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Item Print
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                )}

                {skuTypeSelected && skuTypeSelected.value === 2 && (
                  <MDBox mb={2}>
                    <MDTypography
                      variant="h6"
                      fontWeight="medium"
                      style={{ fontWeight: "500" }}
                    >
                      Primary SKU
                    </MDTypography>

                    <Select
                      isClearable
                      className="select-css"
                      maxMenuHeight={130}
                      placeholder="Choose one..."
                      name="controlType"
                      value={controlTypeSelected}
                      options={controlTypeOptions}
                      onBlur={formikForCreateItem.handleBlur}
                      onChange={(selectedOption) => {
                        handleChangeControlType(selectedOption);
                        formikForCreateItem.setFieldValue(
                          "controlType",
                          selectedOption,
                        );
                      }}
                    />
                    {formikForCreateItem.touched.controlType &&
                      formikForCreateItem.errors.controlType && (
                        <TextError
                          msg={formikForCreateItem.errors.controlType}
                        />
                      )}
                  </MDBox>
                )}
                <MDBox mb={2}>
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    style={{ fontWeight: "500" }}
                  >
                    Qty
                  </MDTypography>

                  <MDInput
                    type="number"
                    name="qty"
                    fullWidth
                    autoComplete="off"
                    onBlur={formikForCreateItem.handleBlur}
                    onChange={formikForCreateItem.handleChange}
                    value={formikForCreateItem.values.qty}
                    error={
                      formikForCreateItem.touched.qty &&
                      formikForCreateItem.errors.qty &&
                      true
                    }
                    inputProps={{
                      style: {
                        height: "10px",
                      },
                    }}
                  />
                  {formikForCreateItem.touched.qty &&
                    formikForCreateItem.errors.qty && (
                      <TextError msg={formikForCreateItem.errors.qty} />
                    )}
                </MDBox>

                <MDBox>
                  <Collapse in={isError}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsError(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {errorMsg}
                    </Alert>
                  </Collapse>
                  <Collapse in={isSuccess}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccess(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      SKU Created successfully
                    </Alert>
                  </Collapse>
                </MDBox>
                <MDBox mt={3}>
                  <MDButton
                    color="info"
                    fullWidth
                    type="submit"
                    disabled={
                      !formikForCreateItem.isValid ||
                      skuTypeSelected === "" ||
                      skuTypeSelected.value === 1
                        ? !selectedItemCode
                        : !controlTypeSelected ||
                          buttonName === "Please wait..."
                    }
                  >
                    {buttonName}
                  </MDButton>
                </MDBox>
              </MDBox>
            </MDBox>
          </MDCard>
        </Modal>
        <Modal
          open={editItemModal}
          onClose={handleCloseEditItemModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <MDCard sx={styleForEdit}>
            <MDBox ml={3} mt={-1} display="flex" alignItems="center">
              <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                Update
              </MDTypography>
              <MDBox>
                <Tooltip title="Close">
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    onClick={handleCloseEditItemModal}
                    style={{
                      background: "whitesmoke",
                      color: "black",
                      borderRadius: 5,
                      // marginLeft: "-55px",
                      // marginBottom: "5px",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </MDBox>
            </MDBox>
            <hr style={{ marginTop: "0rem", marginBottom: "1rem" }} />

            <MDBox pt={0} pb={3} px={3}>
              <MDBox
                component="form"
                role="form"
                onSubmit={formik.handleSubmit}
              >
                <MDBox mb={2}>
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    style={{ fontWeight: "500" }}
                  >
                    Qty
                  </MDTypography>

                  <MDInput
                    type="number"
                    name="qty"
                    fullWidth
                    autoComplete="off"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.qty}
                    error={formik.touched.qty && formik.errors.qty && true}
                    inputProps={{
                      style: {
                        height: "10px",
                      },
                    }}
                  />
                  {formik.touched.qty && formik.errors.qty && (
                    <TextError msg={formik.errors.qty} />
                  )}
                </MDBox>

                <MDBox>
                  <Collapse in={isErrorEditThreshold}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorEditThreshold(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgEditThreshold}
                    </Alert>
                  </Collapse>
                  <Collapse in={isSuccessEditThreshold}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessEditThreshold(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Updated successfully!
                    </Alert>
                  </Collapse>
                </MDBox>
                <MDBox mt={2}>
                  <MDButton
                    fullWidth
                    variant="gradient"
                    color="warning"
                    type="submit"
                    disabled={
                      !formik.isValid || editButtonName === "Please wait..."
                    }
                  >
                    {editButtonName}
                  </MDButton>
                </MDBox>
              </MDBox>
            </MDBox>
          </MDCard>
        </Modal>

        <Modal
          open={printModal}
          onClose={handleClosePrintModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <MDCard sx={styleForEdit}>
            <MDBox ml={3} mt={-1} display="flex" alignItems="center">
              <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                Print
              </MDTypography>
              <MDBox>
                <Tooltip title="Close">
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    onClick={handleClosePrintModal}
                    style={{
                      background: "whitesmoke",
                      color: "black",
                      borderRadius: 5,
                      // marginLeft: "-55px",
                      // marginBottom: "5px",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </MDBox>
            </MDBox>
            <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

            <MDBox pt={1} pb={3} px={3}>
              <MDBox
                component="form"
                role="form"
                onSubmit={formikForPrint.handleSubmit}
              >
                {singleItemMasterDataForEdit?.skuTypeId === 1 && (
                  <MDBox mb={2}>
                    <MDTypography
                      variant="h6"
                      fontWeight="medium"
                      style={{ fontWeight: "500" }}
                    >
                      PO Number
                    </MDTypography>

                    <MDInput
                      type="text"
                      name="poNumber"
                      fullWidth
                      autoComplete="off"
                      onBlur={formikForPrint.handleBlur}
                      onChange={(e) => {
                        formikForPrint.handleChange(e);
                        const newPo = e.target.value;
                        const qty = singleItemMasterDataForEdit?.skuCode;
                        const sku =
                          newPo && qty
                            ? `${newPo}-${qty}-${
                                singleItemMasterDataForEdit?.itemCode ?? ""
                              }`
                            : "";
                        formikForPrint.setFieldValue("skuCode", sku);
                      }}
                      value={formikForPrint.values.poNumber}
                      error={
                        formikForPrint.touched.poNumber &&
                        formikForPrint.errors.poNumber &&
                        true
                      }
                      inputProps={{
                        style: {
                          height: "10px",
                        },
                      }}
                    />
                    {formikForPrint.touched.poNumber &&
                      formikForPrint.errors.poNumber && (
                        <TextError msg={formikForPrint.errors.poNumber} />
                      )}
                  </MDBox>
                )}
                {singleItemMasterDataForEdit?.skuTypeId === 1 && (
                  <MDBox mb={2}>
                    <MDTypography
                      variant="h6"
                      fontWeight="medium"
                      style={{ fontWeight: "500" }}
                    >
                      Batch Number
                    </MDTypography>

                    <MDInput
                      type="text"
                      name="batchNumber"
                      fullWidth
                      autoComplete="off"
                      onBlur={formikForPrint.handleBlur}
                      onChange={(e) => {
                        formikForPrint.handleChange(e);
                        const newBatch = e.target.value;
                        const qty = singleItemMasterDataForEdit?.skuCode;

                        const sku =
                          newBatch && qty
                            ? `${
                                formikForPrint.values.poNumber
                              }/${newBatch}-${qty}-${
                                singleItemMasterDataForEdit?.itemCode ?? ""
                              }`
                            : "";
                        formikForPrint.setFieldValue("skuCode", sku);
                      }}
                      value={formikForPrint.values.batchNumber}
                      error={
                        formikForPrint.touched.batchNumber &&
                        formikForPrint.errors.batchNumber &&
                        true
                      }
                      inputProps={{
                        style: {
                          height: "10px",
                        },
                      }}
                    />
                    {formikForPrint.touched.batchNumber &&
                      formikForPrint.errors.batchNumber && (
                        <TextError msg={formikForPrint.errors.batchNumber} />
                      )}
                  </MDBox>
                )}
                <MDBox mb={2}>
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    style={{ fontWeight: "500" }}
                  >
                    Number of labels
                  </MDTypography>

                  <MDInput
                    type="number"
                    name="qty"
                    fullWidth
                    autoComplete="off"
                    onBlur={formikForPrint.handleBlur}
                    onChange={(e) => {
                      formikForPrint.handleChange(e);
                      const newQty = singleItemMasterDataForEdit?.skuCode;
                      const batch = formikForPrint.values.batchNumber;
                      const poNumber = formikForPrint.values.poNumber;
                      const sku =
                        poNumber && batch && newQty
                          ? `${poNumber}/${batch}-${newQty}-${
                              singleItemMasterDataForEdit?.itemCode ?? ""
                            }`
                          : "";
                      formikForPrint.setFieldValue("skuCode", sku);
                    }}
                    value={formikForPrint.values.qty}
                    error={
                      formikForPrint.touched.qty &&
                      formikForPrint.errors.qty &&
                      true
                    }
                    inputProps={{
                      style: {
                        height: "10px",
                      },
                    }}
                  />
                  {formikForPrint.touched.qty && formikForPrint.errors.qty && (
                    <TextError msg={formikForPrint.errors.qty} />
                  )}
                </MDBox>
                {/* {singleItemMasterDataForEdit?.skuTypeId === 1 && (
                  <MDBox mb={2}>
                    <MDTypography
                      variant="h6"
                      fontWeight="medium"
                      style={{ fontWeight: "500" }}
                    >
                      SKU Code
                    </MDTypography>

                    <MDInput
                      type="text"
                      name="skuCode"
                      readOnly
                      fullWidth
                      autoComplete="off"
                      onBlur={formikForPrint.handleBlur}
                      value={formikForPrint.values.skuCode}
                      error={
                        formikForPrint.touched.skuCode &&
                        formikForPrint.errors.skuCode &&
                        true
                      }
                      inputProps={{
                        style: {
                          height: "10px",
                        },
                        readOnly: true, // auto-populated field should be read-only
                      }}
                    />
                    {formikForPrint.touched.skuCode &&
                      formikForPrint.errors.skuCode && (
                        <TextError msg={formikForPrint.errors.skuCode} />
                      )}
                  </MDBox>
                )} */}
                {singleItemMasterDataForEdit?.skuTypeId === 2 && (
                  <MDBox mb={2}>
                    <MDTypography
                      variant="h6"
                      fontWeight="medium"
                      style={{ fontWeight: "500" }}
                    >
                      SKU Code
                    </MDTypography>

                    <MDInput
                      type="text"
                      name="secondarySkuCode"
                      readOnly
                      fullWidth
                      autoComplete="off"
                      onBlur={formikForPrint.handleBlur}
                      value={formikForPrint.values.secondarySkuCode}
                      error={
                        formikForPrint.touched.secondarySkuCode &&
                        formikForPrint.errors.secondarySkuCode &&
                        true
                      }
                      inputProps={{
                        style: {
                          height: "10px",
                        },
                        readOnly: true, // auto-populated field should be read-only
                      }}
                    />
                    {formikForPrint.touched.secondarySkuCode &&
                      formikForPrint.errors.secondarySkuCode && (
                        <TextError
                          msg={formikForPrint.errors.secondarySkuCode}
                        />
                      )}
                  </MDBox>
                )}
                <MDBox>
                  <Collapse in={isErrorPrint}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorPrint(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgPrint}
                    </Alert>
                  </Collapse>
                  <Collapse in={isSuccessPrint}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessPrint(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Printed successfully!
                    </Alert>
                  </Collapse>
                </MDBox>
                <MDBox mt={2}>
                  <MDButton
                    fullWidth
                    variant="gradient"
                    color="success"
                    type="submit"
                    disabled={
                      !formikForPrint.isValid ||
                      editButtonName === "Please wait..."
                    }
                  >
                    {editButtonName}
                  </MDButton>
                </MDBox>
              </MDBox>
            </MDBox>
          </MDCard>
        </Modal>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getSkuManagementReducer: state.getSkuManagementReducer,
    getSkuManagementWithoutPaginationReducer:
      state.getSkuManagementWithoutPaginationReducer,
    itemMaster: state.itemMaster,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getSkuManagement: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getSkuManagement(pageNo, rowsPerPage, searchObject, jwtToken)),
    editSku: (payload, jwtToken) => dispatch(editSku(payload, jwtToken)),
    printSku: (payload, jwtToken) => dispatch(printSku(payload, jwtToken)),
    printSecondarySku: (payload, jwtToken) =>
      dispatch(printSecondarySku(payload, jwtToken)),
    getSkuManagementWithoutPagination: (jwtToken) =>
      dispatch(getSkuManagementWithoutPagination(jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    createSku: (payload, jwtToken) => dispatch(createSku(payload, jwtToken)),

    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(SkuManagement);
